import { render } from "./QualificationsManagement.vue?vue&type=template&id=00c2dfea&scoped=true"
import script from "./QualificationsManagement.vue?vue&type=script&lang=js"
export * from "./QualificationsManagement.vue?vue&type=script&lang=js"

import "./QualificationsManagement.vue?vue&type=style&index=0&id=00c2dfea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c2dfea"]])

export default __exports__